import { mapEntityProperties } from '@/utils/mapEntityProperties'

export class PaginateEntity<T> {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<T> | null
  constructor(data: Partial<Record<keyof PaginateEntity<T>, unknown>>, model?: T) {
    mapEntityProperties<PaginateEntity<T>>(this, data, {
      map: {
        items: model
      }
    })
  }
}
